export default {
  titles: {
    error: 'Error',
    event: 'Event',
    client: 'Organizer',
    name: 'Name',
    date: 'Date',
  },
  errorCodes: {
    '1000': 'Language missing.',
    '1001': 'Invalid data format.',
    '1002': 'The order is invalid.',
    '1003': 'The order was already submitted.',
    '1004': 'A product wasn\'t found.',
    '1005': 'An admission period wasn\'t found.',
    '1006': 'Invalid time values for admission period/fair.',
    '1007': 'Vat rate not found.',
    '1008': 'Error on processing the order.',
    '1009': 'Admission period missing.',
    '1010': 'Admission period for a product is missing.',
    '1011': 'You cannot use more than one ticket.',
    '1012': 'There are no positions for your order.',
    '1013': 'Could not add product. Slot limit reached.',
    '1014': 'Order not found.',
    '1015': 'Order expired.',
    '1016': 'TOS and privacy agreement missing.',
    '1017': 'Promotion code not found.',
    '1018': 'Promotion code expired.',
    '1019': 'Advertising code not found.',
    '1020': 'No product found for advertising code.',
    '1021': 'Advertising code not found.',
    '1022': 'Could not redeem ticket.',
    '1023': 'Could not redeem ticket.',
    '1024': 'You cannot redeem multiple codes.',
    '1025': 'Could not redeem ticket.',
    '1026': 'Code was not found.',
    '1027': 'Code is invalid.',
    '1028': 'Code was not found.',
    '1029': 'Code was not found.',
    '1055': 'The selected product is not available.',
    '1056': 'The desired quantity cannot be ordered.',
    '1057': 'You cannot claim a personal use on parts of a ticket group.',
    '1058': 'Your payment information could not be processed. Please check your payment information and try again.',
    '1059': 'Your customer information could not be processed. Please check your payment information and try again.',
    '1069': 'The event for this code is already over.',
    '1070': 'Sorry, this code is invalid.',
    '1079': 'Please remove your free additional tickets from the shopping cart first.',
  },
  global: {
    fair: 'Landesmesse Stuttgart GmbH',
    links: {
      toLogin: 'Login',
      toTicketShop: 'To the ticket shop',
      toShoppingCart: 'To the shopping cart',
      back: 'Back',
      lock: 'Complete',
      continue: 'Continue',
      addToShoppingCart: 'Add to shopping cart',
      cancel: 'Cancel',
      change: 'Change',
      update: 'Update',
      done: 'Done',
      orderWithObligationToPay: 'Order with payment obligation',
      requestTicket: 'Request a ticket',
      requestTickets: 'Request tickets',
      removeArticle: 'Remove item',
      emptyShoppingCart: 'Empty shopping cart',
    },
    formWizzard: {
      title: 'Order',
      subtitle: 'Complete your order',
    },
    forms: {
      required: '*',
      requiredInfo: 'Fields marked with * are mandatory.',
      salutation: 'Salutation',
      title: 'Title',
      name: 'Name',
      fullNameHint: 'Name (First name and last name)',
      firstNameHint: 'First name',
      lastNameHint: 'Last name',
      fullNamePlaceholder: 'Martina Mustermann',
      firstNamePlaceHolder: 'Martina',
      lastNamePlaceHolder: 'Mustermann',
      firstName: 'First name',
      lastName: 'Last name',
      company: 'Company',
      additionalInformation: 'Additional information',
      mail: 'E-mail',
      mailConfirm: 'Confirm E-mail',
      address: 'Address',
      street: 'Street',
      number: 'No.',
      zipCode: 'ZIP',
      city: 'City',
      country: 'Country',
      state: 'State',
      date: 'Date',
      dateFrom: 'Date from',
      dateTo: 'Date until',
      yes: 'Yes',
      no: 'No',
      pleaseSelect: 'Select please',
    },
    errorMessages: {
      unfinishedForm: 'The form is incomplete. Please check your entries.',
      dataNotLoadedCorrectly: 'Some data could not be loaded. Please try again.',
    },
    paypal: {
      consentNeeded: 'We need your consent',
      paypalDisabled:
        'Please confirm that you have read the terms and conditions as well as the privacy policy, to complete your order.',
      userCentricsForbidden:
        'Your privacy settings do not allow payment via PayPal. Please accept the privacy settings for PayPal.',
      updateUserCentrics: 'Change privacy settings now',
      toPayment: 'Payment selection',
      acceptPayPal: 'Accept PayPal',
      showInformation: 'More information',
    },
  },
  shopNav: {
    tickets: 'Tickets',
    editProfile: 'Edit profile',
    guest: 'Guest',
    logIn: 'Log in',
    logOut: 'Log out',
    reserved: 'Shopping cart reserved for: ',
    minutes: 'Minutes',
    shoppingCart: 'Shopping cart',
    emptyShoppingCart: 'There are no products in the shopping cart',
    amount: 'Amount: ',
    slot: 'Time slot: ',
    sum: 'Total:',
    sumSubText: '(incl. VAT)',
    titles: {
      toTheTickets: 'To the tickets',
    },
    cartAriaLabel: 'Cart',
  },
  logIn: {
    sideNav: {
      logIn: 'Login',
      register: 'Register',
      orderAsGuest: 'Order as a guest',
    },
    loggedIn: 'You are logged in as',
    guest: {
      bookAsGuest: 'You are booking as a guest',
      yourData: 'Your data:',
      removeData: 'Remove Guest Data',
      newProfile: 'Create a profile now',
      continueAsGuest: 'Continue',
      noGuestProduct:
        'You have products in your shopping cart that do not allow you to order as a guest. <br> ' +
        'Please register with a MyFair login.',
      noLoginProduct:
        'You have products in your shopping cart that do not allow you to place an order as a logged-in user.  <br> ' +
        'Please use guest data.',
      orderAsGuest: 'I would like to order as guest.',
    },
    register: {
      headline: 'I would like to create a user account.',
      infoText: {
        part1:
          'A MyFair user account at Messe Stuttgart has many advantages: <br>' +
          ' You can retrieve purchased tickets online at any time and view your order history and invoice documents. ',
        part2:
          'In addition, you have access to all further digital services of Messe Stuttgart. You can create lists of personal favourites in Exhibitor Indexes as well as your personal interest profile for the newsletter service.',
        postRegistration:
          'After successful registration, you can log in directly to your profile and return to this page.',
      },
      registerNow: 'Register now',
    },
    alreadyRegistered: 'I have a user account already.',
    shopInfo: {
      pleaseLogIn: 'Login with your MyFair user account to conveniently complete your order.',
      pleaseLogInBlanko: 'Log in with your MyFair user account to use the digital services of Messe Stuttgart.',
      info: 'The button "To the trade fair login" will take you to the external My-area. After successful login you will return to this page.',
    },
    addressVerificationModal: {
      headline: 'Would you like to complete your order with the following data?',
    },
  },
  ticketList: {
    error: 'An error has occurred. Please check the configuration of the plugin.',
    selectEvent: 'Select event',
    noAvailableProducts: 'There are no products available for the selected event.',
    includingVAT: 'All prices including VAT.',
    ticketConfiguration: {
      event: 'Event: ',
      price: '(incl. VAT)',
      currency: '€',
      selectSlot: 'Select the desired time slot for your visit',
      info: 'Entitles to one-time access at a venue',
      selectInfo: 'Please select a time slot for each ticket',
      onSitePrice: 'On site:',
      soldOut: 'Sold out',
      noOnSiteSale: 'Kein Verkauf vor Ort',
    },
    filter: {
      headline: 'Filter by:',
      reset: 'Reset filter',
    },
    ticketCode: {
      headline: 'Have you got a ticket code?',
      subHeadline: 'Please enter it here:',
      invalidCode: 'Code {invalidCode} is invalid.',
      promotionCodeInShop: 'The given code {invalidCode} must be entered in the cart.',
      redeemCode: 'Redeem code',
    },
    openingTimes: {
      headline: 'Opening Times',
      time: '',
      missing: 'No information found.',
    },
    buyTicket: {
      headline: 'Buy ticket',
    },
  },
  cart: {
    empty: 'There are no products in your cart.',
    productsHint: 'Your cart contains {0} product(s).',
    headers: {
      ticket: 'Ticket',
      quantity: 'Quantity',
      price: 'Total',
      slot: 'Time slot',
      personalUse: 'Personal use',
    },
    promotionCodes: 'Discount codes on your cart',
    promotionCode: 'Discount code',
    code: 'Code',
    totalSum: 'Total',
    continueShopping: 'Continue shopping',
    goBack: 'Back',
    continue: 'Continue',
    cartItem: {
      includingVat: 'incl.VAT',
      personalUse: 'Personal use',
      quantity: 'Quantity',
      event: 'Event',
      client: 'Client',
      promotionCode: 'Promotion code',
    },
    ticketCode: {
      headline: 'Have you got a ticket code?',
      subHeadline: 'Please enter it here:',
      invalidCode: 'Code {invalidCode} is invalid.',
      usedCode: 'You already used the code {invalidCode}.',
      codeIsRegistrationOrAdvertising: 'The code {0} must be entered in the shop.',
      redeemCode: 'Redeem code',
    },
  },
  registerTickets: {
    claimSuccess: 'Thank you for your order. You will receive an email from us shortly with the tickets.',
    noRegistrationCode: 'Please enter valid codes first to redeem them for a ticket.',
    headline: 'Personalisation of your ticket "{0} {1}"',
    invitationHeadline: 'You were invited',
    from: 'by ',
    invitationText:
      'By redeeming the ticket code, you agree to the transfer of the personal data below to the inviting exhibitor. The purpose of this transfer is to enable the inviting exhibitor to check which of the invited contacts have accepted the invitation.',
    inviterLogoAlt1: 'Logo ',
    inviterLogoAlt2: 'of the inviter',
    code: 'Code: ',
    accountRequiredHint:
      'You need a MyFair profile to redeem this code. Please log in or register if you do not yet have a profile.',
    guestRequiredHint: 'You have to create a guest profile to redeem this code.',
    checkout: {
      selectSlot: 'Select the desired time slot for your visit',
      timeSlot: 'Time slots for "{0} {1}"',
      selectedSlots: 'Selected time slots:',
      addressType: 'Address type',
      transportation: 'Travel options',
      transportationQuestion: 'Would you like to use the free public transport option?',
    },
  },
  privacy: {
    headlineClient: 'Data protection and General Terms and Conditions (GTC) for {eventsTitle}:',
    client: {
      privacyStatement1: 'I have taken note of the ',
      privacyStatement2: 'Data protection',
      privacyStatement3: '',
    },
    agb: {
      iAccept: 'I accept the ',
      agbOf: 'GTC',
    },
  },
  checkout: {
    info: {
      notLoggedIn: 'You are not logged in. Please log in first with a MyFair login or as a guest.',
      noOrderActiveTimer: 'There is currently no order. Please select a product beforehand.',
      noOrderInactiveTimer:
        'There are currently no items in your shopping cart. <br> Possibly the reservation period of 15 minutes has expired. Please go to the ticket shop to continue with the selection.',
      emptyShoppingCart: 'You currently have no products in your shopping cart. Please select a product first.',
      guestLogin: 'You are currently registered as a guest. Please log in with your MyFair login.',
      guestOnly:
        'You have products in your shopping cart that do not allow you to order as a logged in user. Please log out and proceed as guest.',
      quantityError: {
        fromTheProduct: 'From product "{product} are too',
        tooMany: 'many',
        few: 'few',
        ordered: 'Articles ordered.',
        hint: 'Please adjust the number accordingly.',
        minimumOrderQuantity: 'Minimum order quantity: ',
        maximumOrderQuantity: 'Maximum order quantity: ',
      },
    },
    personalisation: {
      title: 'Personalisation',
      hint: 'Please enter all data for your personalised ticket',
      addressType: 'Address type',
      publicTransport: {
        headline: 'Free VVS ticket',
        hintNoPublicTransport: 'No ticket in the shopping cart enables the free VVS option.',
        content:
          'Would you like to add the free VVS option to your ticket? <br> On the day of the event, you can use all local transport in the VVS network at no extra charge.',
        yes: 'Yes',
        no: 'No',
        firstNameHint: 'Name on VVS-Ticket',
        lastNameHint: 'Surname on VVS-Ticket',
        select: 'Select VVS tickets',
        orderHeadline: 'VVS Ticket',
        orderText:
          'Please select on which day you would like to use the VVS ticket. The VVS ticket is only valid on the chosen day (=day of travel).',
        orderTextSingle:
          'Please select your travel date to use the VVS - ticket. ' +
          'The VVS - ticket is only valid on the specified trade fair day (travel date).',
        orderVVSTickets: 'Book VVS tickets',
        orderVVSTicket: 'Book VVS ticket',
        noOrderVVSTicket: 'Do not book VVS tickets',
        noTicketAvailable: 'There is no ticket booking period available.',
        slot: 'Time slot',
        alreadySelected: 'Already selected. ',
        revert: 'Undo',
        validDuringEntireEvent: 'Valid during the entire period of the event.',
        orderVVSTicketsSuccess: 'Your VVS-tickets have been successfully booked.',
        orderVVSTicketsCancellation: 'VVS-Tickets already booked have been successfully cancelled.',
        orderVVSTicketsFailure:
          'Your VVS-tickets could not be booked. Make sure that all necessary fields are filled in.',
      },
      visitorSurvey: {
        headline: 'We have a few more questions',
        subHeadline: '... about your visit to ',
        noQuestions: 'No questions selected for the survey.',
        error: 'Error. This question cannot be displayed.',
        errorInfo: 'Please fill out this field.',
      },
      personalUse: 'Personal use',
      hintNoTickets: 'No tickets selected for own use.',
      hintNoRegistrationRequired: 'You do not have any personalizable tickets in your shopping cart.',
      changeUse: 'Change ticket assignment',
      personalUseModal: {
        headline: ' Would you like to use at least one ticket yourself?/Tickets for your personal use ?',
        info1:
          'Please mark all tickets you intend to use yourself. Then enter your personal data so that we can personalise your ticket(s). ',
        info2:
          'If you order tickets for a third person, you will receive a ticket code at the checkout to forward to the ticket user. The ticket user has to personalise the ticket.',
        info3: 'If you order tickets only for third persons, you can skip this section.',
        info4: 'This ticket does not require personalization.',
        buttonNotAllSelected: 'Please choose Yes or No for all tickets',
        buttonContinue: 'Continue with selection',
        buttonSkip: 'I do not use a ticket for myself.',
        buttonToCheckout: 'Continue to checkout',
      },
    },
    payment: {
      title: 'Payment method',
      hint: 'Choose payment option',
      headline: 'Your payment information',
      invoiceAddressQuestion: 'Would you like to specify a different invoice address?',
      invoiceAddress: 'Yes, I would like to specify a different invoice address.',
      noPaymentData: 'No payment data necessary.',
      creditCard: {
        cardholder: 'Cardholder',
        cardNumber: 'Card number',
        expiryDate: 'Expiry date',
        cvcCvv: 'CVC/CVV',
      },
      sepa: {
        bankName: 'Bank name',
        bic: 'BIC',
        accountHolder: 'Account holder',
        iban: 'IBAN',
        consent:
          'I authorise Concardis GmbH, Helfman-Park 7 in 65760 Eschborn, Creditor ID DE82CC000000346626, ' +
          'Payments from my account by SEPA direct debit under the mandate reference 4d24b95bbfa74df19dbafb1cad411411 to be collected. ' +
          'At the same time, I instruct my credit institution to honour the SEPA direct debits drawn on my account by Concardis GmbH.. ' +
          'Shortening of the notice period: The notice period for the SEPA Direct Debit is shortened to one day. ',
      },
    },
    check: {
      title: 'Check',
      noVVSSelected: 'No reservation.',
      headline: 'Please check your order',
      addresses: {
        orderer: 'Customer',
        invoice: 'Invoice address',
      },
      paymentMethod: 'Payment method',
      noPaymentMethod: 'No payment details required.',
    },
    finished: {
      title: 'Done',
      thanks: 'Thank you for your order. You will receive an e-mail with the details of your order shortly..',
    },
  },
  toasts: {
    logOutSuccess: 'You have been successfully logged out.',
    guestDataRemoved: 'Deposited guest data removed.',
    logOutError: 'An error occurred when logging off. If this error occurs again, please log off in your My Area.',
    removeProduct: 'Product removed from shopping cart',
    removeError: 'Error! Please try again',
    shoppingCartUpdated: 'Shopping cart updated.',
    contingentTicket: 'The contingent for this ticket has been exceeded. The product will not be updated.',
    contingentProduct:
      'The contingent for "{productTitle}" has been exceeded. The shopping cart will not be updated for this ticket.',
    contingentProducts:
      'The contingent for "{productTitles}" has been exceeded. The shopping cart will not be updated for these tickets.',
    improperAmountOfProduct: 'Error {code}: Improper amount of product "{descriptionExternal}" in the shopping cart',
    invalidShoppingCart: 'Error {code}: Invalid shopping cart.',
    knownMail: 'The email address you entered looks familiar to us. Please log in or use a different email address.',
    addedToShoppingCart: 'Added to shopping cart.',
    codeOrProductNotFound: `Your ticket code has expired or could not be found.`,
  },
  checkoutSuccess: {
    ticketGeneration: 'Just a moment! Tickets are generated ({progress}%)',
    error: 'Please check your email inbox for your tickets.',
    noTickets: 'Your order does not include downloadable tickets.',
    registrationCodes: 'Registration codes for passing on to third parties',
  },
};
